import React from 'react'
import './Footer.css'

function Footer() {
  return (
    
    <div className='bgFooter'>
    
<div className="container">
    <div className="row p-3">
        <div className="col foterBoder my-2 foterganiyan">


    © Copyright 2023 GuildQB. All rights reserved

        </div>
    </div>
</div>

</div>
    
    
  )
}

export default Footer